import { useEffect, useState } from "react";
import useApi from "./useApi";

interface DynamicsConfig {
  id: number;
  displayName: string;
  orgName: string;
  instanceUrl: string;
  enabled: boolean;
}

export default function useDynamicsConfigs() {
  const [items, setItems] = useState<DynamicsConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      try {
        const resp = await api.admin.get("Dynamics/Configs");
        const data = await resp.json();
        setItems(Array.isArray(data) ? data : []);
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    }
    fetchConfigs();
  }, [api.admin]);

  return { items, loading };
}
